import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';


const initialState = {    
    loading : false,
    error   : null,
    moduleLists : [],
    success : null,
    fetchData: [],
    relavantListData : [],
    positionList: [],
    departmentList : [],
    keywordValuesList:[],
    sapWorkPermitValuesList:[],
    subordinatesListData:[],
    tableLists:[],
    kotActions:[],   // res/GetresActionAllList, kept apart from tableLists (see actions/kotActions.js)
    commonLists:[],
    requestListData: [],
    calendarData: [],
    containerData: {},
    shiftPatternData: [],
    dependentDetails : [],
    quotaDetails : [],
    requestAttributeData: {},
    employeeWorkSheetData: {},
    employeeDivisionData: [],
    timeOffData: [],
    applicantData:{},
    positionhierarchyData:[],
    requestlistgendata:[],
    dependantdata:[],
    GraphData:[],
    masterData: {},
    selectedBranch: null
}

const moduleStart = (state,action) =>{
    return updateObject(state,{error:null,loading:true})
}

const moduleSuccess = (state,action) =>{
    return updateObject(state,
        {
            moduleLists : action.moduleLists,
            loading : false
        })
}

const moduleFail = (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const masterFormStart = (state,action) =>{
    return updateObject(state,{error:null,loading:true})
}

const masterFormSuccess = (state,action) =>{
    return updateObject(state,
        {
            processMasterLists : action.processMasterLists,
            loading : false,
            success : null,
            error:null,
            fetchData: []
        })
}

const masterFormFail = (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const deleteFormSuccess = (state,action) =>{
    return updateObject(state,
        {
            success:action.success,
            loading:false
        })
}

const deleteFormFail = (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const PositionChartStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const PositionChartSuccess = (state,action) =>{
    return updateObject(state,
        {
            PositionChartData:action.data,
            loading:false
        })
}

const PositionChartFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const fetchProcessStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchProcessSuccess = (state,action) =>{
    return updateObject(state,
        {
            fetchData:action.data,
            loading:false
        })
}

const fetchProcessFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}



const fetchRelavantListStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchRelavantListSuccess = (state,action) =>{
    return updateObject(state,
        {
            relavantListData:action.data,
            loading:false
        })
}

const fetchRelavantListFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const fetchPositionListStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchPositionListSuccess = (state,action) =>{
    return updateObject(state,
        {
            positionList:action.data,
            loading:false
        })
}

const fetchPositionListFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const fetchDepartmentListStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchDepartmentListSuccess = (state,action) =>{
    return updateObject(state,
        {
            departmentList:action.data,
            loading:false
        })
}

const fetchDepartmentListFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const fetchKeywordValueListStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchKeywordValueListSuccess = (state,action) =>{
    return updateObject(state,
        {
            keywordValuesList:action.data,
            loading:false
        })
}

const fetchKeywordValueListFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const fetchSapWorkPermitListStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchSapWorkPermitListSuccess = (state,action) =>{
    return updateObject(state,
        {
            sapWorkPermitValuesList:action.data,
            loading:false
        })
}

const fetchSapWorkPermitListFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const dynamicProcessStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
            error:null,
            success:null
        })
}

const dynamicProcessSuccess = (state,action) =>{
    return updateObject(state,
        {
            loading:false,
            success:action.success,
            error:null
        })
}

const dynamicProcessFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false,
            success:null
        })
}

const tableListStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
            error:null,
            success:null
        })
}

const tableListSuccess = (state,action) =>{
    return updateObject(state,
        {
            loading:false,
            tableLists : action.lists,
            error:null,
            success:null
        })
}

const tableListCommonSuccess = (state,action) =>{
    return updateObject(state,
        {
            loading:false,
            commonLists : action.data
        })
}


const tableListFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false,
        })
}

const dynamicDeleteProcessStart= (state,action) =>{
    return updateObject(state,
        {
            success:null,
            error:null,
            loading:true,
        })
}


const dynamicDeleteProcessFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            success:null,
            loading:false,
        })
}

const dynamicDeleteProcessSuccess= (state,action) =>{
    return updateObject(state,
        {
            success:action.success,
            error:null,
            loading:false,
        })
}



const fetchSubordinatesListStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchSubordinatesListSuccess = (state,action) =>{
    return updateObject(state,
        {
            subordinatesListData:action.data,
            loading:false
        })
}

const fetchSubordinatesListFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}




const fetchRequestStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchRequestSuccess = (state,action) =>{
    return updateObject(state,
        {
            requestListData:action.data,
            loading:false
        })
}

const fetchRequestFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const fetchCalendarDataStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchCalendarDataSuccess = (state,action) =>{
    return updateObject(state,
        {
            calendarData:action.data,
            loading:false
        })
}

const fetchCalendarDataFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const fetchContainerStart = (state,action) =>{
    return updateObject(state,
        {
            containerData: {},
            loading:true
        })
}

const fetchContainerSuccess = (state,action) =>{
    return updateObject(state,
        {
            containerData:action.data,
            loading:false
        })
}

const fetchContainerFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}




const fetchShiftPatternStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchShiftPatternSuccess = (state,action) =>{
    return updateObject(state,
        {
            shiftPatternData:action.data,
            loading:false
        })
}

const fetchDependentDetails = (state,action) => {
    return updateObject(state,
        {
            dependentDetails:action.data,
            loading:false
        })
}

const fetchQuotaDetails = (state,action) => {
    return updateObject(state,
        {
            quotaDetails:action.data,
            loading:false
        })
}

const fetchShiftPatternFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}



const fetchRequestAttributeStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
            requestAttributeData: {},
        })
}

const fetchRequestAttributeSuccess = (state,action) =>{
    return updateObject(state,
        {
            requestAttributeData:action.data,
            loading:false
        })
}

const fetchRequestAttributeFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}




const fetchEmployeeWorkSheetStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
            employeeWorkSheetData: {},
        })
}

const fetchEmployeeWorkSheetSuccess = (state,action) =>{
    return updateObject(state,
        {
            employeeWorkSheetData:action.data,
            loading:false
        })
}

const fetchEmployeeWorkSheetFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const clearCacheStorage = (state, { data = {} }) => {
    return updateObject(state, Object.assign({}, {...data}))
}


const fetchEmployeeDivisionStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
            employeeDivisionData: [],
        })
}

const fetchEmployeeDivisionSuccess = (state,action) =>{
    return updateObject(state,
        {
            employeeDivisionData:action.data,
            loading:false
        })
}

const fetchEmployeeDivisionFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const fetchTimeOffStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
            timeOffData: [],
        })
}

const fetchTimeOffSuccess = (state,action) =>{
    return updateObject(state,
        {
            timeOffData:action.data,
            loading:false
        })
}

const fetchTimeOffFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const fetchApplicantStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
            applicantData: [],
        })
}

const fetchApplicantSuccess = (state,action) =>{
    return updateObject(state,
        {
            applicantData:action.data,
            loading:false
        })
}

const fetchApplicantFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const GetPositionHierachyGraphStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const GetPositionHierachyGraphSuccess = (state,action) =>{
    return updateObject(state,
        {
            positionhierarchyData:action.data,
            loading:false
        })
}

const GetPositionHierachyGraphFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const fetchrequestListgenStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchrequestListgenSuccess = (state,action) =>{
    return updateObject(state,
        {
            requestlistgendata:action.data,
            loading:false
        })
}

const fetchrequestListgenFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}


const fetchdependantStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchdependantSuccess = (state,action) =>{
    return updateObject(state,
        {
            dependantdata:action.data,
            loading:false
        })
}

const fetchdependantFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const fetchGetGraphDataStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true
        })
}

const fetchGetGraphDataSuccess = (state,action) =>{
    return updateObject(state,
        {
            GraphData:action.data,
            loading:false
        })
}

const fetchGetGraphDataFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}
//Storing multiple maaster data 
const masterDataStart = (state, action) => {
    return updateObject(state, {
        loading: true,
        error: null
    });
};


const masterDataSuccess = (state, action) => {
    

    return updateObject(state, {
        loading: false,
        masterData: {
            ...state.masterData,
            [action.table]: action.data
        },
        error: null
    });

};


const masterDataFail = (state, action) => {

    return updateObject(state, {
        loading: false,
        error: action.error
    });

};

const setSelectedBranch = (state, action) => {
    return updateObject(state, {
        selectedBranch: action.branch
    });
};

const masterReducer = ( state = initialState, action) =>{
    switch(action.type){
        case actionTypes.MODULE_START: return moduleStart(state,action);
        case actionTypes.MODULE_SUCCESS: return moduleSuccess(state,action);
        case actionTypes.MODULE_FAIL: return moduleFail(state,action);

        case actionTypes.PROCESS_MASTERLIST_START: return masterFormStart(state,action);
        case actionTypes.PROCESS_MASTERLIST_SUCCESS: return masterFormSuccess(state,action);
        case actionTypes.PROCESS_MASTERLIST_FAIL: return masterFormFail(state,action);

        case actionTypes.PROCESS_MASTERDELETE_SUCCESS: return deleteFormSuccess(state,action);
        case actionTypes.PROCESS_MASTERDELETE_FAIL: return deleteFormFail(state,action);
        
        case actionTypes.PROCESS_FETCH_START: return fetchProcessStart(state,action);
        case actionTypes.PROCESS_FETCH_SUCCESS: return fetchProcessSuccess(state,action);
        case actionTypes.PROCESS_FETCH_FAIL: return fetchProcessFail(state,action);

        case actionTypes.FETCH_RELAVANT_LIST_START: return fetchRelavantListStart(state,action);
        case actionTypes.FETCH_RELAVANT_LIST_SUCCESS: return fetchRelavantListSuccess(state,action);
        case actionTypes.FETCH_RELAVANT_LIST_FAIL: return fetchRelavantListFail(state,action);


        case actionTypes.FETCH_POSITION_LIST_START: return fetchPositionListStart(state,action);
        case actionTypes.FETCH_POSITION_LIST_SUCCESS: return fetchPositionListSuccess(state,action);
        case actionTypes.FETCH_POSITION_LIST_FAIL: return fetchPositionListFail(state,action);

        case actionTypes.FETCH_DEPARTMENT_LIST_START: return fetchDepartmentListStart(state,action);
        case actionTypes.FETCH_DEPARTMENT_LIST_SUCCESS: return fetchDepartmentListSuccess(state,action);
        case actionTypes.FETCH_DEPARTMENT_LIST_FAIL: return fetchDepartmentListFail(state,action);


        case actionTypes.FETCH_KEYWORDVALUE_LIST_START: return fetchKeywordValueListStart(state,action);
        case actionTypes.FETCH_KEYWORDVALUE_LIST_SUCCESS: return fetchKeywordValueListSuccess(state,action);
        case actionTypes.FETCH_KEYWORDVALUE_LIST_FAIL: return fetchKeywordValueListFail(state,action);

        case actionTypes.FETCH_SAPWORKPERMIT_LIST_START: return fetchSapWorkPermitListStart(state,action);
        case actionTypes.FETCH_SAPWORKPERMIT_LIST_SUCCESS: return fetchSapWorkPermitListSuccess(state,action);
        case actionTypes.FETCH_SAPWORKPERMIT_LIST_FAIL: return fetchSapWorkPermitListFail(state,action);


        case actionTypes.DYNAMIC_PROCESS_START: return dynamicProcessStart(state,action);
        case actionTypes.DYNAMIC_PROCESS_SUCCESS: return dynamicProcessSuccess(state,action);
        case actionTypes.DYNAMIC_PROCESS_FAIL: return dynamicProcessFail(state,action);

        case actionTypes.TABLE_LIST_START: return tableListStart(state,action);
        case actionTypes.TABLE_LIST_SUCCESS: return tableListSuccess(state,action);
        case actionTypes.TABLE_LIST_FAIL: return tableListFail(state,action);

        case actionTypes.KOT_ACTIONS_START: return updateObject(state,{ loading:true, error:null, success:null });
        // A live refresh (loud:false) swaps the rows and leaves the page loader alone.
        case actionTypes.KOT_ACTIONS_SET: return updateObject(state, action.loud
            ? { kotActions:action.rows, loading:false, error:null, success:null }
            : { kotActions:action.rows });
        case actionTypes.KOT_ACTIONS_FAIL: return updateObject(state,{ loading:false, error:action.error, success:null });
        case actionTypes.TABLE_COMMON_LIST_SUCCESS: return tableListCommonSuccess(state,action);
        

        case actionTypes.DYNAMIC_DELETE_PROCESS_START: return dynamicDeleteProcessStart(state,action);
        case actionTypes.DYNAMIC_DELETE_PROCESS_SUCCESS: return dynamicDeleteProcessSuccess(state,action);
        case actionTypes.DYNAMIC_DELETE_PROCESS_FAIL: return dynamicDeleteProcessFail(state,action);

        case actionTypes.FETCH_SUBORDINATES_LIST_START: return fetchSubordinatesListStart(state,action);
        case actionTypes.FETCH_SUBORDINATES_LIST_SUCCESS: return fetchSubordinatesListSuccess(state,action);
        case actionTypes.FETCH_SUBORDINATES_LIST_FAIL: return fetchSubordinatesListFail(state,action);
       
        case actionTypes.FETCH_REQUEST_START: return fetchRequestStart(state,action);
        case actionTypes.FETCH_REQUEST_SUCCESS: return fetchRequestSuccess(state,action);
        case actionTypes.FETCH_REQUEST_FAIL: return fetchRequestFail(state,action);
        
        case actionTypes.FETCH_CALENDAR_DATA_START: return fetchCalendarDataStart(state,action);
        case actionTypes.FETCH_CALENDAR_DATA_SUCCESS: return fetchCalendarDataSuccess(state,action);
        case actionTypes.FETCH_CALENDAR_DATA_FAIL: return fetchCalendarDataFail(state,action);

        case actionTypes.FETCH_CONTAINER_START: return fetchContainerStart(state,action);
        case actionTypes.FETCH_CONTAINER_SUCCESS: return fetchContainerSuccess(state,action);
        case actionTypes.FETCH_CONTAINER_FAIL: return fetchContainerFail(state,action);

        case actionTypes.FETCH_SHIFT_PATTERN_START: return fetchShiftPatternStart(state,action);
        case actionTypes.FETCH_SHIFT_PATTERN_SUCCESS: return fetchShiftPatternSuccess(state,action);
        case actionTypes.FETCH_SHIFT_PATTERN_FAIL: return fetchShiftPatternFail(state,action);

        case actionTypes.FETCH_DEPENDENT_DETAILS : return fetchDependentDetails(state,action);
        case actionTypes.FETCH_QUOTA_DETAILS : return fetchQuotaDetails(state,action);
        
        case actionTypes.FETCH_REQUEST_ATTRIBUTE_START: return fetchRequestAttributeStart(state,action);
        case actionTypes.FETCH_REQUEST_ATTRIBUTE_SUCCESS: return fetchRequestAttributeSuccess(state,action);
        case actionTypes.FETCH_REQUEST_ATTRIBUTE_FAIL: return fetchRequestAttributeFail(state,action);

        case actionTypes.FETCH_EMPLOYEE_WORK_SHEET_START: return fetchEmployeeWorkSheetStart(state,action);
        case actionTypes.FETCH_EMPLOYEE_WORK_SHEET_SUCCESS: return fetchEmployeeWorkSheetSuccess(state,action);
        case actionTypes.FETCH_EMPLOYEE_WORK_SHEET_FAIL: return fetchEmployeeWorkSheetFail(state,action);

        case actionTypes.CLEAR_CACHE: return clearCacheStorage(state,action);

        case actionTypes.FETCH_EMPLOYEE_DIVISION_START: return fetchEmployeeDivisionStart(state,action);
        case actionTypes.FETCH_EMPLOYEE_DIVISION_SUCCESS: return fetchEmployeeDivisionSuccess(state,action);
        case actionTypes.FETCH_EMPLOYEE_DIVISION_FAIL: return fetchEmployeeDivisionFail(state,action);

        case actionTypes.FETCH_TIME_OFF_START: return fetchTimeOffStart(state,action);
        case actionTypes.FETCH_TIME_OFF_SUCCESS: return fetchTimeOffSuccess(state,action);
        case actionTypes.FETCH_TIME_OFF_FAIL: return fetchTimeOffFail(state,action);

        case actionTypes.FETCH_APPLICANT_START: return fetchApplicantStart(state,action);
        case actionTypes.FETCH_APPLICANT_SUCCESS: return fetchApplicantSuccess(state,action);
        case actionTypes.FETCH_APPLICANT_FAIL: return fetchApplicantFail(state,action);
        
        case actionTypes.GET_POSITIONHIERARCHY_GRAPH_START: return GetPositionHierachyGraphStart(state,action);
        case actionTypes.GET_POSITIONHIERARCHY_GRAPH_SUCCESS: return GetPositionHierachyGraphSuccess(state,action);
        case actionTypes.GET_POSITIONHIERARCHY_GRAPH_FAIL: return GetPositionHierachyGraphFail(state,action);

        case actionTypes.FETCH_REQUESTLISTGEN_START: return fetchrequestListgenStart(state,action);
        case actionTypes.FETCH_REQUESTLISTGEN_SUCCESS: return fetchrequestListgenSuccess(state,action);
        case actionTypes.FETCH_REQUESTLISTGEN_FAIL: return fetchrequestListgenFail(state,action);

        case actionTypes.FETCH_DEPENDANT_START: return fetchdependantStart(state,action);
        case actionTypes.FETCH_DEPENDANT_SUCCESS: return fetchdependantSuccess(state,action);
        case actionTypes.FETCH_DEPENDANT_FAIL: return fetchdependantFail(state,action);
        
        case actionTypes.FETCH_GET_GRAPHDATA_START: return fetchGetGraphDataStart(state,action);
        case actionTypes.FETCH_GET_GRAPHDATA_SUCCESS: return fetchGetGraphDataSuccess(state,action);
        case actionTypes.FETCH_GET_GRAPHDATA_FAIL: return fetchGetGraphDataFail(state,action);

        case actionTypes.MASTER_DATA_START:  return masterDataStart(state, action);
        case actionTypes.MASTER_DATA_SUCCESS: return masterDataSuccess(state, action);
        case actionTypes.MASTER_DATA_FAIL: return masterDataFail(state, action);
        case actionTypes.SET_SELECTED_BRANCH:  return setSelectedBranch(state, action);

        default:
            return state;

    }
}






export default masterReducer;